/**
 * sw-pr-gw-customer-dashboard
 * SpendWyze Payment Request Gateway Customer Dashboard
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PayerAttendedPaymentRequestTaskInputPayer { 
    /**
     * The account number of the transaction's payer.
     */
    accountNumber?: string;
    /**
     * The name of the transaction's payer.
     */
    name?: string;
    /**
     * Email address of the payer
     */
    emailAddress: string;
}